const language_it = {
    invoice_enhancement: "Ottimizzazione delle fatture",
  };

  export default language_it;